@use "~theme/typographyV2.scss" as typography;
@use "~theme/breakpoints";
.wearOption {
  height: 87.19px;
  width: 308.93px;
  border-radius: 8px;
  border: 1px solid var(--white);
  background-color: var(--white);
  outline: none;
  box-shadow: 0px 4px 8px 0px rgb(0 0 0 / 10%);
  cursor:pointer;
  padding: 15px 12px;
}

// .wearOption:hover {
//   border-color: var(--blue-01-at-30);
// }

// .wearOption:active {
//   filter: drop-shadow(0 2px 6px var(--highlight-blue));
//   border-color: var(--white);
// }

// .wearOption:focus-within {
//   filter: drop-shadow(0 2px 6px var(--highlight-blue));
// }

.wearOptionNameContainer {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  float: left;
  width:60%;
}

.addMargin {    
  margin: 5px 0px;
}

.wearOptionName {
  font-family: typography.$font-mont;
  font-weight: 400;
  font-style: normal;
  line-height: 120%;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  margin: auto;
  font-size: 14px;
}

.radio{
    float: left;
    width:10%;
    margin: 0 5px 0 0;
    height: 100%;
    display: flex;
    align-items: center;
}

.icon{
    float: left;
    width:20%;
    margin: 0 14px 0 0;
    border: 3px solid var(--border-blue);
    border-radius: 4px;
}


.wearOptionMobile {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  background: var(--white);
  box-shadow: 0px 4px 8px 0px rgb(0 0 0 / 10%);
  border-radius: 8px;
  width: 145px;
  height: 129.19px;
  padding: 15px 12px;
  border: 1px solid var(--white);
  box-sizing: border-box;
  cursor:pointer;
  text-transform: capitalize;
  @include breakpoints.desktop {
    text-transform: uppercase;
  }

  .wearOptionNameContainer {
    width: 121px;
    float: none;
    height: 34px;
    min-height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .addMargin {    
    margin: 0px;
    padding: 0px;
  }
  .addMarginIcon {    
    transform: translateY(-6px);
  }
  
  .wearOptionName {
    font-weight: 400;
    font-size: 14px;
    line-height: 140%;
    width: 121px;
    max-width: 121px;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    letter-spacing: 0;
    color: rgba(35, 31, 32, 1);
    word-break: normal;
    overflow-wrap: break-word;
    text-transform: uppercase;
    @include breakpoints.desktop {
      text-transform: uppercase;
    }
  }

  .icon{
    width: 53px;
    float: none;
    margin: 0;
    margin-right: 0;
    border: 3px solid var(--border-blue);
    border-radius: 4px;
  }
}

.selected {
  border: 4px solid var(--highlight-blue);
  box-shadow: 0px 4px 8px 0px rgb(0 0 0 / 10%);
}
